/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { stringify } from 'qs'

const INVOICE_BASE_LINK = '/admin/invoices'

export function getInvoiceCreateLink (params?: Record<string, unknown>) {
  return `${INVOICE_BASE_LINK}/create?${stringify(params)}`
}

export function getInvoiceLink (id: number) {
  return `${INVOICE_BASE_LINK}/${id}/edit`
}

export function getInvoiceLinkTemplate () {
  return `${INVOICE_BASE_LINK}/{id}/edit`
}

export function getInvoiceListLink (params?: Record<string, unknown>) {
  return `${INVOICE_BASE_LINK}?${stringify(params)}`
}
